"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticField = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const utils_1 = require("@react-aria/utils");
const Css_1 = require("../Css");
const defaultTestId_1 = require("../utils/defaultTestId");
const useTestIds_1 = require("../utils/useTestIds");
function StaticField(props) {
    const { label, value, children } = props;
    const tid = (0, useTestIds_1.useTestIds)(props, typeof label === "string" ? (0, defaultTestId_1.defaultTestId)(label) : "staticField");
    const id = (0, utils_1.useId)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { css: Css_1.Css.db.sm.gray700.mbPx(4).$, htmlFor: id, ...tid.label, children: label }), (0, jsx_runtime_1.jsx)("div", { id: id, css: Css_1.Css.smMd.gray900.df.aic.$, ...tid, children: value || children })] }));
}
exports.StaticField = StaticField;
